<template>
  <div> 
    
    <!-- -->
      <div class="bluesection">            
        <img src="img/transplus.png" id="tplogo" alt="" class="adlogo" />                  
        <h2 class="title">Request Callback</h2>
      </div>    

      <div class="section">
        <div class="container">          

            <div class="col-md-5  ml-auto mr-auto ">
              <form id="contact-form" >                
                <div class="row">
                  <label  v-html="$t('Contact.Name')">Name</label>
                  <input type="name" aria-describedby="addon-right addon-left"  class="custom_form" v-model="Contact.Name">

                  <label  :class="{ 'custom_form error': $v.data.DIVISION.$error }">Company</label>
                  <input type="company" aria-describedby="addon-right addon-left"  class="custom_form" v-model="Contact.Company">

                  <label  v-html="$t('Contact.Phone')" >Phone Number</label>
                  <input type="phone" aria-describedby="addon-right addon-left" class="custom_form" v-model="Contact.Phone">

                  <div style="width:100%;" v-if="Contact.Company && Contact.Phone">
                    <div class="text-center" ><button type="button" class="btnBlue" v-on:click="sendmessage"><!---->SUBMIT<!----></button></div>
                  </div>

                </div>
                  
              </form>
            </div>

        </div>
      </div>
  </div>
</template>
<script>
import axios from 'axios'
import { required, email,minLength } from 'vuelidate/lib/validators'

export default {
  validations: {
    Contact: {
      Name: { required },
      Phone: { required },
      Company: { required },
      Department: { required },
      //Email: { required, email }
    },
    data:{    
      DIVISION: { required },
      Message: { minLength: minLength(10) }
    }
  },  
  data() {
    return {    
      year: new Date().getFullYear(),
      Contact: {
        Name: null,
        Company: null,
        Phone: null,
        Email: ''
      },
      data:{
        DIVISION: 'WAREHOUSE',
        Message: 'REQUEST CALL BACK'
      },    
    };
  },
  mounted: function (){
           
  },
  created: function(){     
    
  },
  methods:{

    sendmessage() {
        
        this.$v.Contact.$touch();

        this.data.Message = 'REQUEST CALL BACK ' + this.Contact.Name + ' phone: ' + this.Contact.Phone
        // if its still pending or an error is returned do not submit
        if (this.$v.Contact.Phone.$error || this.$v.data.Message.$error || this.$v.data.DIVISION.$error) {        
          return;
        }
        

        axios.post('https://api.transplus.com/adContact/', {data: this.data, contact: this.Contact, subject: 'Call back request ⭐'} )
        .then((response) => {
          this.$router.push('/thankyou');        
        })
        .catch(e => {
          alert(e)
          console.log(e)
        })
         
    }
  }
};
</script>

<style scoped>
::placeholder {
  color: rgb(205, 205, 205);
}
label {
  margin-top:15px;
}
.adlogo {
    height:60px; 
    filter: brightness(0) invert(1);
}
.custom_form {
  
  border:1px solid #333;
  width: 100%;
  padding: 12px 20px;
  margin-bottom: 8px;
  box-sizing: border-box;
}

.custom_form:focus {
  outline: none !important;
  border:1px solid #55B550;
  box-shadow: 0 0 4px #55B550;
}

.error {
  border:1px solid #800020;
  box-shadow: 0 0 4px #800020 ;
}


.hoverblue {
  color: #999;
  background-color: rgb(245, 245, 245);
  border-width: 0;
  font-weight: bold;
  font-size: 12px;    
  margin: 20px 1px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}
.hoverblue:hover{
  color: white;
  background-color: dodgerblue;
}

.negative-section{
  
  /*
    width:100%;
    margin-left: auto;
    margin-right: auto;
    margin-top: -100px;
    height:400px;    
    z-index:99;
  */    
}
.btnBlue{
  background-color:dodgerblue;
  text-align:center;
  border-radius: 5px;
  border-style: solid;
  border-color: dodgerblue;  
  color: white;
  font-size: 1.6em;
  width:200px;
  margin:5px;
  transition: width 1s;
  padding: 11px 22px 11px 22px;  
}
.btnBlue:hover {
  background-color:#58a8f5;
}
.turngreen {
  transition: 0.3s;
  margin:10px;
}
.turngreen:hover {
   background-color:#55B550; 
   color:white; 
   border-radius: 5px;
   margin-bottom:10px;
}

@media only screen and (max-width: 600px) {  
  .negative-section{
      text-align:center;
  }
}

</style>
